export default __webpack_public_path__ + "media/VisualFeaturing.6d2f123c.png";